"use client";

// A night room lays its OWN wash over the page while it is open.
//
// ⚠️ It sets `--ground-grad` ITSELF, not the four stops it is normally built
// from (`--g-a` … `--g-top`). ThemeProvider writes those stops from the
// visitor's own ground on mount and on every ground change, and it runs after
// this on a fresh load: the room's wash was wiped to `transparent` and only
// survived when you arrived by a client-side link. Overriding the finished
// gradient cannot be fought by a writer of its ingredients.

import { useEffect } from "react";
import type { Wash } from "./communityTheme";

export function useRoomWash(wash: Wash | null): void {
  useEffect(() => {
    if (!wash) return;
    const root = document.documentElement;
    const prev = root.style.getPropertyValue("--ground-grad");
    root.style.setProperty(
      "--ground-grad",
      [
        `radial-gradient(128% 84% at 4% -10%, ${wash.a} 0%, transparent 64%)`,
        `radial-gradient(112% 76% at 106% 0%, ${wash.b} 0%, transparent 60%)`,
        `radial-gradient(136% 98% at 44% 118%, ${wash.c} 0%, transparent 70%)`,
        `linear-gradient(180deg, ${wash.top} 0%, transparent 64%)`,
      ].join(", "),
    );
    root.dataset.roomNight = "";
    return () => {
      if (prev) root.style.setProperty("--ground-grad", prev);
      else root.style.removeProperty("--ground-grad");
      delete root.dataset.roomNight;
    };
  }, [wash]);
}
